import initialState from './initialState';
import {
  PERIOD_ADMIN_SAVE_INIT,
  PERIOD_ADMIN_SAVE_SUCCESS,
  PERIOD_ADMIN_SAVE_FAILURE,
  PERIOD_ADMIN_SET_SAVE_DATA_BY_KEY,
  PERIOD_ADMIN_SAVE_RESET,
  PERIOD_ADMIN_GET_PERIODS_LIST_INIT,
  PERIOD_ADMIN_GET_PERIODS_LIST_SUCCESS,
  PERIOD_ADMIN_GET_PERIODS_LIST_FAILURE,
  PERIOD_ADMIN_SET_ACTIVE_PERIOD,
  PERIOD_ADMIN_CHANGE_PERIOD_STATE_INIT,
  PERIOD_ADMIN_CHANGE_PERIOD_STATE_SUCCESS,
  PERIOD_ADMIN_CHANGE_PERIOD_STATE_FAILURE,
  PERIOD_ADMIN_CLOSE_PERIOD_INIT,
  PERIOD_ADMIN_CLOSE_PERIOD_SUCCESS,
  PERIOD_ADMIN_CLOSE_PERIOD_FAILURE,
  PERIOD_ADMIN_GET_GROUPS_INIT,
  PERIOD_ADMIN_GET_GROUPS_SUCCESS,
  PERIOD_ADMIN_GET_GROUPS_FAILURE,
  PERIOD_ADMIN_GET_CALCULATION_UNITS_INIT,
  PERIOD_ADMIN_GET_CALCULATION_UNITS_SUCCESS,
  PERIOD_ADMIN_GET_CALCULATION_UNITS_FAILURE,  
  PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT,
  PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS,
  PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE,
  PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_INIT,
  PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS,
  PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE,
  PERIOD_ADMIN_IMPORT_INIT,
  PERIOD_ADMIN_IMPORT_SUCCESS,
  PERIOD_ADMIN_IMPORT_FAILURE,
  PERIOD_ADMIN_IMPORT_RESET,
  PERIOD_ADMIN_GET_IMPORT_FILES_LIST_INIT,
	PERIOD_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS,
	PERIOD_ADMIN_GET_IMPORT_FILES_LIST_FAILURE,
  PERIOD_ADMIN_CALCULATE_INIT,
  PERIOD_ADMIN_CALCULATE_SUCCESS,
  PERIOD_ADMIN_CALCULATE_FAILURE,	
	PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_INIT,
	PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS,
	PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE,
	PERIOD_ADMIN_DELETE_CALCULATION_PREPARE_INIT,
	PERIOD_ADMIN_DELETE_CALCULATION_INIT,
	PERIOD_ADMIN_DELETE_CALCULATION_SUCCESS,
	PERIOD_ADMIN_DELETE_CALCULATION_FAILURE,
	PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT,
	PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS,
	PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE,
  PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT,
  PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS,
  PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE,
  PERIOD_ADMIN_GET_POLYNOMIALS_LIST_INIT,
  PERIOD_ADMIN_GET_POLYNOMIALS_LIST_SUCCESS,
  PERIOD_ADMIN_GET_POLYNOMIALS_LIST_FAILURE,  
  PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_INIT,
  PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_SUCCESS,
  PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_FAILURE,
  PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_INIT,
  PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_SUCCESS,
  PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_FAILURE,
  PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT,
  PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS,
  PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE,
  PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_INIT,
  PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS,
  PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE,
  PERIOD_ADMIN_EXPORT_BI_REPORTS_INIT,
  PERIOD_ADMIN_EXPORT_BI_REPORTS_SUCCESS,
  PERIOD_ADMIN_EXPORT_BI_REPORTS_FAILURE,
  PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_INIT,
  PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_SUCCESS,
  PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_FAILURE,
  PERIOD_ADMIN_SOFT_RESET,
  PERIOD_ADMIN_RESET,
  PERIOD_ADMIN_GET_CUSTOMER_INIT,
  PERIOD_ADMIN_GET_CUSTOMER_SUCCESS,
  PERIOD_ADMIN_GET_CUSTOMER_FAILURE,
  PERIOD_ADMIN_ROLL_BACK_PERIOD_INIT,
  PERIOD_ADMIN_ROLL_BACK_PERIOD_SUCCESS,
  PERIOD_ADMIN_ROLL_BACK_PERIOD_FAILURE,
  PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_INIT,
  PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_SUCCESS,
  PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_FAILURE,
} from '../../actions/periodAdmin/types';
import ReducersTooling from '../../../tooling/reducersTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';

export default function periodAdmin(state = initialState, action) {
  switch (action.type) {      
    case PERIOD_ADMIN_GET_PERIODS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "periodsList");
    case PERIOD_ADMIN_GET_PERIODS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "periodsList");
    case PERIOD_ADMIN_GET_PERIODS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "periodsList");
    case PERIOD_ADMIN_SET_ACTIVE_PERIOD:
      return {
        ...state,
        findActive: action.payload
      };
    case PERIOD_ADMIN_SAVE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitSave(initialState, state, action, "save");
    case PERIOD_ADMIN_SAVE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessSave(initialState, state, action, "save");
    case PERIOD_ADMIN_SAVE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureSave(initialState, state, action, "save");
    case PERIOD_ADMIN_SET_SAVE_DATA_BY_KEY:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSetDataByKeySave(initialState, state, action, "save");
    case PERIOD_ADMIN_SAVE_RESET:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateResetSave(initialState, state, action, "save");
    case PERIOD_ADMIN_CHANGE_PERIOD_STATE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "changePeriodState");
    case PERIOD_ADMIN_CHANGE_PERIOD_STATE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "changePeriodState");
    case PERIOD_ADMIN_CHANGE_PERIOD_STATE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "changePeriodState");
    case PERIOD_ADMIN_CLOSE_PERIOD_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "closePeriod");
    case PERIOD_ADMIN_CLOSE_PERIOD_SUCCESS:
      var findActiveOldState = JavascriptUtilsTooling.deepCopy(state.findActive);
      if(action.payload.status == 200) {
        findActiveOldState.data.processing_closure = true;
      }
      return {
        ...(ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "closePeriod")),
        findActive:findActiveOldState
      };
    case PERIOD_ADMIN_CLOSE_PERIOD_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "closePeriod");
    case PERIOD_ADMIN_GET_GROUPS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "groupsFilter");
    case PERIOD_ADMIN_GET_GROUPS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "groupsFilter");
    case PERIOD_ADMIN_GET_GROUPS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "groupsFilter");
    case PERIOD_ADMIN_GET_CALCULATION_UNITS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationUnitsFilter");
    case PERIOD_ADMIN_GET_CALCULATION_UNITS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationUnitsFilter");
    case PERIOD_ADMIN_GET_CALCULATION_UNITS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationUnitsFilter");
    case PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "metricsGroupsWithDefaults");
    case PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS:
      let newMetricsDefaultsUploadInfo = [];
      action.payload.data.forEach((item) => {
        newMetricsDefaultsUploadInfo.push(ReducersTooling.initialStates.getFetchTypeInitialState())
      });
      return {
        ...(ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "metricsGroupsWithDefaults")),
        metricsDataUploadInfo: newMetricsDefaultsUploadInfo
      }
    case PERIOD_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "metricsGroupsWithDefaults");
    case PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadImport");
    case PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadImport");
    case PERIOD_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadImport");
    case PERIOD_ADMIN_IMPORT_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "import");
    case PERIOD_ADMIN_IMPORT_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "import");
    case PERIOD_ADMIN_IMPORT_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "import");
    case PERIOD_ADMIN_IMPORT_RESET:
      return ReducersTooling.generalReducers.getFetchTypeNewStateReset(initialState, state, action, "import");
    case PERIOD_ADMIN_GET_IMPORT_FILES_LIST_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "importFilesList");
    case PERIOD_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "importFilesList");
    case PERIOD_ADMIN_GET_IMPORT_FILES_LIST_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "importFilesList");
    case PERIOD_ADMIN_CALCULATE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "calculate");
    case PERIOD_ADMIN_CALCULATE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "calculate");
    case PERIOD_ADMIN_CALCULATE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "calculate");	
    case PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "calculationsHistory");
    case PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "calculationsHistory");
    case PERIOD_ADMIN_GET_CALCULATIONS_HISTORY_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "calculationsHistory");	
	case PERIOD_ADMIN_DELETE_CALCULATION_PREPARE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStatePrepareDelete(initialState, state, action, "deleteCalculation");
    case PERIOD_ADMIN_DELETE_CALCULATION_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitDelete(initialState, state, action, "deleteCalculation");
    case PERIOD_ADMIN_DELETE_CALCULATION_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessDelete(initialState, state, action, "deleteCalculation");
    case PERIOD_ADMIN_DELETE_CALCULATION_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureDelete(initialState, state, action, "deleteCalculation");	  
	case PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadCalculationReport");
    case PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadCalculationReport");
    case PERIOD_ADMIN_DOWNLOAD_CALCULATION_REPORT_FILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadCalculationReport");
    case PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadCalculationUnifiedReport");
    case PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadCalculationUnifiedReport");
    case PERIOD_ADMIN_DOWNLOAD_CALCULATION_UNIFIED_REPORT_FILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadCalculationUnifiedReport");
    case PERIOD_ADMIN_GET_POLYNOMIALS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "polynomialsList");
    case PERIOD_ADMIN_GET_POLYNOMIALS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "polynomialsList");
    case PERIOD_ADMIN_GET_POLYNOMIALS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "polynomialsList");
    case PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "polynomialsSubModelList");
    case PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "polynomialsSubModelList");
    case PERIOD_ADMIN_GET_POLYNOMIALS_SUB_MODEL_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "polynomialsSubModelList");
    case PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_INIT:
      let newMetricsDataUploadInfo = JavascriptUtilsTooling.deepCopy(state.metricsDataUploadInfo);
      let oldFirstLoading = newMetricsDataUploadInfo[action.index]!=undefined ? newMetricsDataUploadInfo[action.index].firstLoading : true;
      newMetricsDataUploadInfo[action.index] = {
        ...ReducersTooling.initialStates.getFetchTypeInitialState(),
        firstLoading: oldFirstLoading,
        loading: true,
      };
      return {
        ...state,
        metricsDataUploadInfo: newMetricsDataUploadInfo
      };
      
    case PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_SUCCESS:
      let newMetricsDataUploadInfoSucess = JavascriptUtilsTooling.deepCopy(state.metricsDataUploadInfo);
      newMetricsDataUploadInfoSucess[action.index] = {
        ...state.metricsDataUploadInfo[action.index],
        firstLoading: false,
        errors: (action.payload.status == 200) ? null: action.payload.data,
        loading: false,
        status: action.payload.status,
        data: action.payload.data,
      };
      return {
        ...state,
        metricsDataUploadInfo: newMetricsDataUploadInfoSucess
      };
    case PERIOD_ADMIN_GET_METRICS_DATA_UPLOAD_INFO_FAILURE:
      let newMetricsDataUploadInfoFailure = JavascriptUtilsTooling.deepCopy(state.metricsDataUploadInfo);
      newMetricsDataUploadInfoFailure[action.index] = {
        ...ReducersTooling.initialStates.getFetchTypeInitialState(),
        firstLoading: false,
        errors: action.error,
        status: 500,
      };
      return {
        ...state,
        metricsDataUploadInfo: newMetricsDataUploadInfoFailure
      };
    case PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "processingMetricsImportsNotifications");
    case PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "processingMetricsImportsNotifications");
    case PERIOD_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "processingMetricsImportsNotifications");
    case PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "biTemplatesList");
    case PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "biTemplatesList");
    case PERIOD_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "biTemplatesList");
    case PERIOD_ADMIN_EXPORT_BI_REPORTS_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "exportBiReports");
    case PERIOD_ADMIN_EXPORT_BI_REPORTS_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "exportBiReports");
    case PERIOD_ADMIN_EXPORT_BI_REPORTS_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "exportBiReports");
    case PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "polynomialFilterTreeInfo");
    case PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "polynomialFilterTreeInfo");
    case PERIOD_ADMIN_GET_POLYNOMIAL_FILTER_TREE_INFO_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "polynomialFilterTreeInfo");
    case PERIOD_ADMIN_SOFT_RESET:
      return {
        ...initialState,
        periodsList: state.periodsList,
        findActive: state.findActive,
        metricsGroupsWithDefaults: state.metricsGroupsWithDefaults,
        importFilesList: state.importFilesList,        
        polynomialsList: state.polynomialsList,
        polynomialsSubModelList: state.polynomialsSubModelList,
        biTemplatesList: state.biTemplatesList
      };
    case PERIOD_ADMIN_RESET:
      return initialState;
    case PERIOD_ADMIN_GET_CUSTOMER_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "getCustomer");
    case PERIOD_ADMIN_GET_CUSTOMER_SUCCESS:
      return{
        ...(ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "getCustomer")),
        unAuthorized:(action.payload.status == 401) ? true : false,
      };
    case PERIOD_ADMIN_GET_CUSTOMER_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "getCustomer");
    case PERIOD_ADMIN_ROLL_BACK_PERIOD_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "rollBackPeriod");
    case PERIOD_ADMIN_ROLL_BACK_PERIOD_SUCCESS:
      var findActiveOldState = JavascriptUtilsTooling.deepCopy(state.findActive);
      if(action.payload.status == 200) {
        findActiveOldState.data.processing_rollback = true;
      }
      return {
        ...(ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "rollBackPeriod")),
        findActive:findActiveOldState
      };
    case PERIOD_ADMIN_ROLL_BACK_PERIOD_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "rollBackPeriod");
    case PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "refreshVirtualMetricData");
    case PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "refreshVirtualMetricData");
    case PERIOD_ADMIN_LOAD_VIRTUAL_METRIC_DATA_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "refreshVirtualMetricData");
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/periodAdmin/index.js